export default function authorizedMiddleware({ to, next, store, nextMiddleware }) {
  console.info("<authorizedMiddleware> isAuth: ", store.getters.isAuth);

  const user = store.getters.getUser;

  if (!user || !user.id) {
    store.state.token = "";

    return next({ name: "common.login" });
  }

  const productGroups = store.getters.getProductGroups || [];
  const hasNoProductAccess = productGroups.length === 0;

  const dashboardWhiteList = ["dashboard.home", "dashboard.analytics.list", "dashboard.team.management"];

  if (hasNoProductAccess && !dashboardWhiteList.includes(to.name)) {
    return next("/not-found");
  }

  if (store.getters.isAuth) {
    return nextMiddleware();
  }

  return next({
    name: "common.login",
    query: { redirect: to.fullPath },
  });
}
